import moment from 'moment';
import { getData } from '@/components/report/service';
import { computeWeightNotAbs } from '@/utils/query';
import { PlanWeightDetialQuery } from '../Tables/PlanDepartureTable/Sql';
import { crudRequest } from '@/services/api';
import { sum } from 'lodash-es';
import { aggreArrItem, groupBys } from '@/utils/columnSearch';

export const ModalsType = { SITE: 1, CENTER: 2 }
export default {
  namespace: 'centerWeightViewModals',
  state: {
    modalsVisible: false,
    /**
     * @modalsType
     * 1: 网点预到达
     * 2: 中转预到达
     * 3: 在库
    */
    modalsType: '',
    modalsTitle: '',
    modalsNextSite: '',

    // 预计
    estimateTitle: '',
    estimateList: [],
    estimatePage: 1,
    // 实际
    actualTitle: '',
    actualList: [],
    actualPage: 1,


    ProductTypeModalsVisible: false,
    nextSite: '',

    planProductList: [],       // 预计到达产品类型图
    acount: 0,                 // 预计到达上一站总货量
    preSiteToNextSiteList: [], // 预计到达上一站分布
    planWeightDetialList: [], // 导出明细
  },
  effects: {
    // 重置
    *setReset(_, { put }) {
      yield put({
        type: 'update',
        payload: {
          modalsVisible: false,
          estimateList: [],
          estimatePage: 1,
          actualList: [],
          actualPage: 1,
        },
      });
    },
    *getSelect({ payload }, { put, select }) {
      yield put({ type: 'update', payload: { ...payload } });
      const { modalsType } = yield select(({ centerWeightViewModals }) => centerWeightViewModals)
      if (modalsType) {
        crudRequest(`/api/route/centerweightview/${modalsType === ModalsType.SITE ? 'site' : 'center'}_search_detail`)
      }
      yield put({ type: 'getDataSource' });
    },
    *getDataSource(_, { call, put, select }) {
      let { centerFilter: scanSite, startDate, endDate } = yield select(({ centerWeightView }) => {
        return {
          centerFilter: centerWeightView.centerFilter,
          startDate: moment(centerWeightView.dateRange[0]).format(centerWeightView.defualtDateFormat),
          endDate: moment(centerWeightView.dateRange[1]).format(centerWeightView.defualtDateFormat),
        }
      });

      const { modalsNextSite: nextSite, modalsType } = yield select(({ centerWeightViewModals }) => centerWeightViewModals)
      const isOriginCenter = modalsType === ModalsType.SITE ? '是' : '否'
      const dimension = modalsType === ModalsType.SITE ? 'originSite' : 'preSite'
      const params = { scanSite, nextSite, startDate, endDate, isOriginCenter, dimension }
      const { plan, actual } = PlanWeightDetialQuery(params)
      let planProductList = yield call(getData, plan)
      // const preSites = planProductList.map(m => m.preSite)
      // const { actual } = PlanWeightDetialQuery({ ...params })
      let actualProductList = yield call(getData, actual)
      if (modalsType === ModalsType.SITE) {
        planProductList.forEach(m => m.preSite = m.originSite)
        actualProductList.forEach(m => m.preSite = m.originSite)
      }

      const dataSource = []
      planProductList.forEach(planItem => {
        let {
          waybillNo, preSite, calcWeight, goodsWeight,
          goodsVolume, productType, ticket, piece
        } = planItem
        const find = actualProductList.find(actualItem => {
          return (
            planItem.waybillNo === actualItem.waybillNo &&
            planItem.preSite === actualItem.preSite &&
            planItem.productType === actualItem.productType
          )
        })
        if (find) {
          calcWeight = calcWeight - find.calcWeight
          goodsWeight = goodsWeight - find.goodsWeight
          goodsVolume = goodsVolume - find.goodsVolume
          ticket = ticket - find.ticket
          piece = piece - find.piece
        }
        if (piece > 0) {
          // acount += calcWeight
          dataSource.push({
            waybillNo, preSite, calcWeight, goodsWeight,
            goodsVolume, productType, ticket, piece
          })
        }
      })
      yield put({ type: 'getPlanDepartureProduct', payload: { dataSource } });
      yield put({ type: 'getPreSiteToNextSite', payload: { dataSource } });
      yield put({ type: 'update', payload: { planWeightDetialList: dataSource } })
    },
    *getPlanDepartureProduct({ payload: { dataSource } }, { call, put, select }) {
      let dataSourceGroup = groupBys(dataSource, 'productType')
      let planProductList = []
      Object.keys(dataSourceGroup).map(item => {
        const aggResult = aggreArrItem(
          dataSourceGroup[item],
          ['calcWeight']
        )
        planProductList.push(aggResult)
      })
      planProductList = planProductList.map(item => {
        return ({ name: item.productType, value: computeWeightNotAbs(item.calcWeight) })
      })
      yield put({ type: 'update', payload: { planProductList } })
    },
    *getPreSiteToNextSite({ payload: { dataSource } }, { call, put, select }) {
      let acount = 0
      let dataSourceGroup = groupBys(dataSource, 'preSite')
      let preSiteToNextSiteList = []
      Object.keys(dataSourceGroup).map(item => {
        const aggResult = aggreArrItem(
          dataSourceGroup[item],
          ['calcWeight', 'goodsVolume', 'ticket', 'piece']
        )
        acount = acount + (aggResult?.calcWeight || 0)
        preSiteToNextSiteList.push(aggResult)
      })
      preSiteToNextSiteList = preSiteToNextSiteList.sort((a, b) => b.calcWeight - a.calcWeight).map(item => ({
        ...item, proportion: (item.calcWeight / acount * 100).toFixed(1)
      }))
      yield put({ type: 'update', payload: { preSiteToNextSiteList, acount } })
    },
  },
  reducers: {
    update(state, { payload }) {
      return { ...state, ...payload };
    },
  }
}
